
export default {
  name: 'FiveStarProductsSectionBanner',

  props: {
    data: {
      type: Object,
      default: () => ({
      }),
    },
    desktopImage: {
      type: Object,
      default: () => {},
    },
    mobileImage: {
      type: Object,
      default: () => {},
    },
    breadcrumbTitle: {
      type: String,
      default: null,
    }
  },

  data() {
    return {
      isActive: true,
    }
  },

  computed: {
    computedDesktopImage() {
      return this.desktopImage?.url ? this.desktopImage : this.data?.BannerImageDesktop;
    },
    computedMobileImage() {
      return this.mobileImage?.url ? this.mobileImage : this.data?.BannerImageMobile;
    },
    h1_text(){
      let h1Text = ''

      if(this.$route?.params?.productCat === 'insurer-of-the-year' && this.$route?.params?.productSubCat === 'life') {
        h1Text = this.$t('h1_text.lifeInsurerOfTheYear');
      }
      else if(this.$route?.params?.productCat === 'insurer-of-the-year' && this.$route?.params?.productSubCat === 'health') {
        h1Text = this.$t('h1_text.healthInsurerOfTheYear');
      }
      else if(this.$route?.params?.productCat === 'insurer-of-the-year') {
        h1Text = this.$t('h1_text.lifeInsurerOfTheYear');
      }
      else if(this.$route?.params?.productCat === 'vhis') {
        h1Text = this.$t('h1_text.vhis');
      }
      else if(this.$route?.params?.productCat === 'high-end-medical') {
        h1Text = this.$t('h1_text.highEndMedical');
      }
      else if(this.$route?.params?.productCat === 'whole-life-critical-illness-insurance') {
        h1Text = this.$t('h1_text.wholeLifeCriticalIllness');
      }
      else if(this.$route?.params?.productCat === 'term-critical-illness') {
        h1Text = this.$t('h1_text.termCriticalIllness');
      }
      else if(this.$route?.params?.productCat === 'savings' && this.$route?.params?.productSubCat === 'education') {
        h1Text = this.$t('h1_text.savingInsuranceForEducation');
      }
      else if(this.$route?.params?.productCat === 'savings' &&  this.$route?.params?.productSubCat === 'retirement') {
        h1Text = this.$t('h1_text.savingInsuranceForRetirement');
      }
      else if(this.$route?.params?.productCat === 'savings' &&  this.$route?.params?.productSubCat === 'legacy') {
        h1Text = this.$t('h1_text.savingInsuranceForLegacy');
      }
      else if(this.$route?.params?.productCat === 'savings') {
        h1Text = this.$t('h1_text.savingInsuranceForEducation');
      }
      else if(this.$route?.params?.productCat === 'whole-life-protection') {
        h1Text = this.$t('h1_text.wholeLifeProtection');
      }

      return h1Text
    }
  },
  
  mounted() {
    if(this.$route?.params?.productCat === 'insurer-of-the-year' && this.$route?.params?.productSubCat === 'life') {
        this.isActive = true;
      }
      else if(this.$route?.params?.productCat === 'insurer-of-the-year' && this.$route?.params?.productSubCat === 'health') {
        this.isActive = true;
      }
      else if(this.$route?.params?.productCat === 'insurer-of-the-year') {
        this.isActive = true;
      }
      else if(this.$route?.params?.productCat === 'vhis') {
        this.isActive = true;
      }
      else if(this.$route?.params?.productCat === 'high-end-medical') {
        this.isActive = true;
      }
      else if(this.$route?.params?.productCat === 'whole-life-critical-illness-insurance') {
        this.isActive = true;
      }
      else if(this.$route?.params?.productCat === 'term-critical-illness') {
        this.isActive = true;
      }
      else if(this.$route?.params?.productCat === 'savings' && this.$route?.params?.productSubCat === 'education') {
        this.isActive = true;
      }
      else if(this.$route?.params?.productCat === 'savings' &&  this.$route?.params?.productSubCat === 'retirement') {
        this.isActive = true;
      }
      else if(this.$route?.params?.productCat === 'savings' &&  this.$route?.params?.productSubCat === 'legacy') {
        this.isActive = true;
      }
      else if(this.$route?.params?.productCat === 'savings') {
        this.isActive = true;
      }
      else if(this.$route?.params?.productCat === 'whole-life-protection') {
        this.isActive = true;
      }
      else if(!this.$route?.params?.productCat) {
        this.isActive = false;
      }
  },

}
